var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * Nothing specific to GPT here, only a generic character-level
 * dataset wrapper.
 *
 * A helper wrapper on top of any txt-file-based character-level
 * dataset. It loads arbitrary txt file,treats each letter as a token,
 * splits the characters into training and testing batches,
 * encodes/decodes letters to indices and vice versa.
 */
import * as tf from '@tensorflow/tfjs';
// Creates a character-level dataset, where each letter is a token.
export function CharDataset(args) {
    return __awaiter(this, void 0, Promise, function () {
        var textSourceURL, _a, textSource, _b, maskZero, indexShift, text, _c, textSize, chars, vocabSize, stoi, itos, encode, decode, data, dataSize, n, trainData, valData, getBatch, dispose;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    textSourceURL = args.textSourceURL, _a = args.textSource, textSource = _a === void 0 ? '' : _a, _b = args.maskZero, maskZero = _b === void 0 ? true : _b;
                    indexShift = maskZero ? 1 : 0;
                    if (!textSourceURL) return [3 /*break*/, 3];
                    return [4 /*yield*/, fetch(textSourceURL)];
                case 1: return [4 /*yield*/, (_d.sent()).text()];
                case 2:
                    _c = _d.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _c = textSource;
                    _d.label = 4;
                case 4:
                    text = _c;
                    textSize = text.length;
                    chars = Array.from(new Set(text)).sort();
                    vocabSize = chars.length;
                    stoi = Object.fromEntries(chars.map(function (ch, i) { return [ch, i + indexShift]; }));
                    itos = Object.fromEntries(chars.map(function (ch, i) { return [i + indexShift, ch]; }));
                    encode = function (s) { return s.split('').map(function (c) { return stoi[c]; }); };
                    decode = function (a) { return a.map(function (i) { return itos[i]; }).join(''); };
                    data = tf.tensor(encode(text), [textSize], 'int32');
                    dataSize = data.shape[0];
                    n = Math.floor(0.9 * textSize);
                    trainData = data.slice(0, n);
                    valData = data.slice(n);
                    getBatch = function (args) {
                        return tf.tidy(function () {
                            var split = args.split, blockSize = args.blockSize, batchSize = args.batchSize;
                            var data = split === 'train' ? trainData : valData;
                            var maxval = data.shape[0] - blockSize;
                            var ix = tf.randomUniform([batchSize], 0, maxval, 'int32'); // (B)
                            var ranges = tf.range(0, blockSize, 1, 'int32').expandDims(0); // (1,T)
                            var indices = ix.expandDims(1).add(ranges); // (B,T)
                            var x = tf.gather(data, indices); // (B,T)
                            var y = tf.gather(data, indices.add(tf.scalar(1, 'int32'))); // (B,T)
                            return { x: x, y: y };
                        });
                    };
                    dispose = function () {
                        data.dispose();
                        trainData.dispose();
                        valData.dispose();
                    };
                    return [2 /*return*/, {
                            textSourceURL: textSourceURL,
                            vocabSize: vocabSize,
                            vocabulary: chars,
                            dataSize: dataSize,
                            text: text,
                            getBatch: getBatch,
                            encode: encode,
                            decode: decode,
                            dispose: dispose,
                        }];
            }
        });
    });
}
